const checkMonth = (e) => {
  switch (e) {
    case 1:
      return "JAN";
    case 2:
      return "FEB";
    case 3:
      return "MAR";
    case 4:
      return "APR";
    case 5:
      return "MAY";
    case 6:
      return "JUN";
    case 7:
      return "JUL";
    case 8:
      return "AUG";
    case 9:
      return "SEP";
    case 10:
      return "OCT";
    case 11:
      return "NOV";
    default:
      return "DEC";
  }
};
export const getDate = (e) => {
  let timestamp = new Date(e);

  let month = timestamp.getMonth() + 1;
  let year = timestamp.getFullYear();
  let date = timestamp.getDate();

  return date + " " + checkMonth(month) + " " + year;
};

export const getDateWithTime = (e) => {
  let timestamp = new Date(e);

  let month = timestamp.getMonth() + 1;
  let year = timestamp.getFullYear();
  let date = timestamp.getDate();
  let hours = ("00" + timestamp.getHours()).slice(-2);
  let mins = ("00" + timestamp.getMinutes()).slice(-2);
  let seconds = ("00" + timestamp.getSeconds()).slice(-2);

  return (
    date +
    " " +
    checkMonth(month) +
    " " +
    year +
    " " +
    hours +
    ":" +
    mins +
    ":" +
    seconds
  );
};

export const exportToCsv = (csv, fileName) => {
  let now = new Date();

  var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, "MDS_Bonus.csv");
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${fileName}_${now.toISOString()}.csv`);
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
